/**
 * useCheckinAvailable
 * -------------------
 * Liefert `true`, wenn der aktuell eingeloggte Kunde mindestens einen
 * Termin hat, der vom Master zum Check-In freigeschaltet wurde
 * (`checkin_enabled === true`) und noch nicht eingecheckt ist.
 *
 * Wird verwendet, um Check-In-Buttons/Links kontextabhängig ein- und
 * auszublenden. Ohne Login → false.
 *
 * Wird bei jedem Mount und optional per Refresh-Trigger aktualisiert.
 */
import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useCheckinAvailable = () => {
  const { isAuthenticated, user } = useAuth();
  const userId = user?.id;
  const [available, setAvailable] = useState(false);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!isAuthenticated) { setAvailable(false); return; }
    setLoading(true);
    try {
      const r = await axios.get(`${API_URL}/api/appointments`);
      const list = r.data || [];
      const has = list.some(a => a?.checkin_enabled && a?.status === 'scheduled' && a?.user_id === userId);
      setAvailable(has);
    } catch (_e) {
      setAvailable(false);
    } finally { setLoading(false); }
  }, [isAuthenticated, userId]);

  // Reset immediately on any identity change so a stale "available" from
  // the previous account never flashes before the fresh fetch resolves.
  useEffect(() => { setAvailable(false); }, [userId]);

  useEffect(() => { refresh(); }, [refresh]);

  return { available, loading, refresh };
};

export default useCheckinAvailable;
